
export enum ConversionStatisticsType {
    CONVERSION_TYPE = 'CONVERSION_TYPE',
    CALCULATOR_NAME = 'CALCULATOR_NAME',
    CAMPAIGN_TYPE = 'CAMPAIGN_TYPE'
}